// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3RSyK","dragIcon":"Choice_dragIcon__1nhmp","left":"Choice_left__38M0s","input":"Choice_input__R6nhG"};